import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

type rangeData = {
  start: Date | string | number | undefined;
  end: Date | string | number | undefined;
};

@Pipe({
  name: 'datetimeRange',
})
export class DatetimeRangePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(
    date: rangeData,
    format: 'short' | 'condensed' | 'full' = 'condensed',
    timezone: string | undefined = undefined
  ): string {
    if (format === 'short') {
      return this.formatShortRange(date, timezone);
    } else if (format === 'condensed') {
      return this.formatCondesedRange(date, timezone);
    } else {
      return this.formatFullRange(date, timezone);
    }
  }

  formatShortRange(date: rangeData, timezone: string | undefined = undefined) {
    if (
      this.datePipe.transform(date.start, 'shortDate', timezone) ===
      this.datePipe.transform(date.end, 'shortDate', timezone)
    ) {
      return '' + this.datePipe.transform(date.start, 'mediumDate', timezone);
    } else {
      return (
        this.datePipe.transform(date.start, 'mediumDate', timezone) +
        ' - ' +
        this.datePipe.transform(date.end, 'mediumDate', timezone)
      );
    }
  }

  formatCondesedRange(date: rangeData, timezone: string | undefined = undefined) {
    if (
      this.datePipe.transform(date.start, 'shortDate', timezone) ===
      this.datePipe.transform(date.end, 'shortDate', timezone)
    ) {
      return (
        this.datePipe.transform(date.start, 'mediumDate', timezone) +
        ' ' +
        this.datePipe.transform(date.start, 'shortTime', timezone) +
        ' - ' +
        this.datePipe.transform(date.end, 'shortTime', timezone)
      );
    } else {
      return (
        this.datePipe.transform(date.start, 'mediumDate', timezone) +
        ' - ' +
        this.datePipe.transform(date.end, 'mediumDate', timezone)
      );
    }
  }

  private formatFullRange(date: rangeData, timezone: string | undefined = undefined) {
    if (
      this.datePipe.transform(date.start, 'shortDate', timezone) ===
      this.datePipe.transform(date.end, 'shortDate', timezone)
    ) {
      return (
        this.datePipe.transform(date.start, 'fullDate', timezone) +
        ' ' +
        this.datePipe.transform(date.start, 'shortTime', timezone) +
        ' - ' +
        this.datePipe.transform(date.end, 'shortTime', timezone)
      );
    } else {
      return (
        this.datePipe.transform(date.start, 'fullDate', timezone) +
        ' ' +
        this.datePipe.transform(date.start, 'shortTime', timezone) +
        ' - ' +
        this.datePipe.transform(date.end, 'fullDate', timezone) +
        ' ' +
        this.datePipe.transform(date.end, 'shortTime', timezone)
      );
    }
  }
}
